import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutRecurringPayAdjustmentList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceDrsRecurDeduct: DataSource;
    tableRecuringPayAdjustments: Table;
}
